import { ValidateResponse } from '@cemex-core/cmx-api/models/validate/validate-res';
import { Order } from '@cemex-core/cmx-api';
import { GroupingLoad } from '@cemex-core/cmx-api/models/grouping/grouping-load';
import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { GroupingActions, GroupingActionTypes } from '../actions/grouping.actions';

export interface GroupingState {
  loading: boolean;
  loads: GroupingLoad[];
  draftId: number | null;
  validateResponse: ValidateResponse;
  draftOrder: Order | null;
}

export const initialState: GroupingState = {
  loading: false,
  loads: [],
  draftId: null,
  validateResponse: null,
  draftOrder: null,
};

export function groupingReducer(state = initialState, action: GroupingActions | OrderBuilderActions): GroupingState {
  switch (action.type) {
    case GroupingActionTypes.CREATE_ODM_ORDER_LOAD:
    case GroupingActionTypes.LOAD: {
      return {
        ...state,
        ...initialState,
        loading: true,
      } as GroupingState;
    }
    case GroupingActionTypes.CREATE_ODM_ORDER_LOAD_COMPLETE:
    case GroupingActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        loads: [...action.payload.loads],
        draftId: action.payload.draftId,
      } as GroupingState;
    }
    case GroupingActionTypes.UPDATE_LOAD_DATE: {
      return {
        ...state,
        loads: state.loads.map(load => {
          if (load.loadNumber === action.payload.load.loadNumber) {
            return { ...load, programmedDateTime: action.payload.newDate };
          } else {
            return load;
          }
        }),
      } as GroupingState;
    }
    case GroupingActionTypes.BULK_UPDATE_LOAD_DATE: {
      return {
        ...state,
        loads: state.loads.map(load => {
          return { ...load, programmedDateTime: action.payload };
        }),
      } as GroupingState;
    }
    case GroupingActionTypes.UPDATE_COUNTER_OFFERS: {
      return {
        ...state,
        loads: state.loads.map(load => {
          if (load.loadNumber === action.payload.load.loadNumber) {
            return { ...load, counterOffers: action.payload.counterOffers };
          } else {
            return load;
          }
        }),
      } as GroupingState;
    }
    case GroupingActionTypes.SET_DRAFT_ORDER: {
      return {
        ...state,
        draftOrder: action.payload,
      };
    }
    case GroupingActionTypes.SET_VALIDATE_RESPONSE: {
      return {
        ...state,
        validateResponse: action.payload,
      };
    }
    case RESET_BUILDER:
    case GroupingActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
